import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useOutsideClick } from '../../helpers/clickOutside';
import { ReactComponent as MenuButtonSVG } from '../../icons/table/menu-button.svg';
import { ReactComponent as ChevronSVG } from '../../icons/chevron-right.svg';

const TableCellSelect = ({
  options,
  onUpdate,
  value,
  readOnly,
  'data-cy': dataCy,
}) => {
  const menuRef = useRef(null);
  const [showOther, setShowOther] = useState(false);
  const [otherValue, setOtherValue] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useOutsideClick(menuRef, () => setShowDropdown(false));

  const onToggleDropdown = (e) => {
    if (e.target.id !== 'other') setShowDropdown(!showDropdown);
  };

  const onSelect = (option) => {
    if (option.id === 'other') {
      setShowOther(true);
    } else {
      onUpdate(option.value);
    }
  };

  const option = options && options.find((o) => o.value === value);

  const display = option?.label ? option.label : value;

  const selectClasses = classnames('th-list-data', {
    pointer: !readOnly,
  });

  return (
    <div
      id="th-cell-header"
      data-cy={dataCy}
      ref={menuRef}
      className={selectClasses}
      onClick={readOnly ? () => {} : (event) => onToggleDropdown(event)}
    >
      <div className="flex justify-between ">
        <h3 className="ma0 pa0 th-members-list-name ">
          {display === 'Blank' || display === undefined ? '' : display}
        </h3>
        {!readOnly && <MenuButtonSVG />}
      </div>
      {showDropdown && (
        <div
          className="th-select-filter-dropdown"
          style={{
            width: document.getElementById('th-cell-header').offsetWidth - 1,
            marginTop: '5px',
          }}
        >
          <ul
            role="listbox"
            className="th-select-options"
            style={{ maxHeight: '30vh', overflow: 'auto' }}
          >
            {options.map(
              (option) =>
                option.id !== 'dont-need-to-be-qualified' && (
                  <li
                    role="option"
                    key={option.id}
                    id={option.id}
                    className={
                      option.id === 'blank' || option.id === 'other'
                        ? 'th-select-option pointer fw6 i'
                        : 'th-select-option pointer'
                    }
                    aria-selected={option.selected}
                    onClick={() => onSelect(option)}
                  >
                    {option.label}
                    {showOther && option.id === 'other' && (
                      <div className="mt2 input-group">
                        <input
                          id="other"
                          type="text"
                          name="other-text"
                          value={otherValue || ''}
                          onChange={(e) => setOtherValue(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              onUpdate(otherValue);
                              setShowDropdown(false);
                            }
                          }}
                        />
                        <div
                          className="pointer"
                          onClick={() => onUpdate(otherValue)}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '10px',
                          }}
                        >
                          <div>
                            <ChevronSVG />
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                ),
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

TableCellSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
    }),
  ),
  onUpdate: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  'data-cy': PropTypes.string,
};

export default TableCellSelect;
